import React, { useState } from "react";

const HoverFullText = ({ text, className = "", sliceLength = 12 }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const [copied, setCopied] = useState(false);
    const displayText = text == null ? "" : String(text);

    const handleClick = () => {
        navigator.clipboard.writeText(displayText);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div
            className={`relative cursor-pointer ${className}`}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            onClick={handleClick}
        >
            <span>
                {displayText.length > sliceLength
                    ? `${displayText.slice(0, sliceLength)}...`
                    : displayText}
            </span>

            {showTooltip && displayText && (
                <div className="absolute left-0 bottom-full mb-1 z-50 w-max max-w-[25vmax] bg-gray-800 text-white
         text-xs p-1 rounded shadow-lg break-words">
                    {copied ? "Copied!" : displayText}
                </div>
            )}
        </div>
    );
};

export default HoverFullText;
